import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, InlineEditableText
} from './ThemeLayoutHelpers';

export default function LunarLayout({ p }) {
  const T = p.storeTheme || {};
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: T.themeId === "eclipse" ? "Eclipse Collection" : "Lunar Collection",
    title: T.themeId === "eclipse" ? "Mysterious & bold" : "Simplicity in every detail",
    subtitle: T.themeId === "eclipse" ? "Vibrant neon highlights on a dark surface" : "Minimalist design meets functionality",
    primaryCta: "View Products",
    secondaryCta: "About Us",
  });

  return (
    <div className="min-h-screen flex flex-col text-gray-300" style={{ backgroundColor: T.backgroundColor || "#0a0a0a", fontFamily: T.fontFamily || "Inter, sans-serif" }}>
      {/* Minimal Navigation */}
      <nav className="sticky top-0 z-40 backdrop-blur border-b border-white/5" style={{ backgroundColor: T.backgroundColor ? `${T.backgroundColor}f2` : "#0a0a0a95" }}>
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <StoreLogo storeInfo={p.storeInfo} size="h-8 w-8" border="border border-white/20" />
            <span className="text-sm font-light tracking-wide uppercase">{p.storeInfo?.businessName}</span>
          </div>
          <div className="hidden md:flex items-center gap-6 text-sm">
            <button onClick={() => p.setActiveTab("products")} className={`hover:text-white transition ${p.activeTab === "products" ? "text-white" : "text-gray-500"}`}>{text.products || "Products"}</button>
            <button onClick={() => p.setActiveTab("services")} className={`hover:text-white transition ${p.activeTab === "services" ? "text-white" : "text-gray-500"}`}>{text.services || "Services"}</button>
            <button onClick={() => p.setActiveTab("details")} className={`hover:text-white transition ${p.activeTab === "details" ? "text-white" : "text-gray-500"}`}>{text.about || "About"}</button>
          </div>
          <div className="flex items-center gap-3">
            <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} dark className="hidden md:block w-64" />
            <CartBtn p={p} dark />
            {p.userMenuElement}
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative h-[70vh] min-h-[500px]">
        <HeroImage p={p} themeId={T.themeId || "lunar"} className="h-full">
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/80 pointer-events-none" />
        </HeroImage>
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div className="max-w-2xl px-4">
            <span className="text-xs tracking-[0.3em] uppercase text-gray-400"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
            <h1 className="text-5xl md:text-6xl font-light tracking-tight text-white mt-4"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
            <p className="mt-4 text-gray-300"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
            <div className="mt-8 flex gap-4 justify-center">
              <button onClick={() => p.setActiveTab("products")} className="px-8 py-3 bg-white text-black font-medium hover:bg-gray-200 transition"><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
              <button onClick={() => p.setActiveTab("details")} className="px-8 py-3 border border-white/30 text-white font-medium hover:bg-white/10 transition"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
            </div>
          </div>
        </div>
      </section>

      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-12">
        <TabContent p={p} dark />
      </section>

      <StoreFooter p={p} dark />
    </div>
  );
}